import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetAllLocationsQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
}>;


export type GetAllLocationsQuery = { __typename?: 'query_root', locations: Array<{ __typename?: 'locations', id: number, active: number, address?: string | null, address_line_one?: string | null, address_line_two?: string | null, city?: string | null, state?: string | null, zip_code?: string | null, createdat?: string | null, customer_id?: number | null, email?: string | null, favorite: boolean, latitude?: number | null, longitude?: number | null, name?: string | null, nickname?: string | null, phone?: string | null, place_id?: string | null, region_id?: number | null, timezone?: string | null, tookan_id?: number | null, type: string, updatedat?: string | null }> };


export const GetAllLocationsDocument = gql`
    query getAllLocations($customerId: bigint!) {
  locations(
    where: {active: {_eq: 1}, customer_id: {_eq: $customerId}}
    order_by: [{favorite: desc}, {name: asc}]
  ) {
    id
    active
    address
    address_line_one
    address_line_two
    city
    state
    zip_code
    createdat
    customer_id
    email
    favorite
    latitude
    longitude
    name
    nickname
    phone
    place_id
    region_id
    timezone
    tookan_id
    type
    updatedat
  }
}
    `;

/**
 * __useGetAllLocationsQuery__
 *
 * To run a query within a React component, call `useGetAllLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLocationsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetAllLocationsQuery(baseOptions: Apollo.QueryHookOptions<GetAllLocationsQuery, GetAllLocationsQueryVariables> & ({ variables: GetAllLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllLocationsQuery, GetAllLocationsQueryVariables>(GetAllLocationsDocument, options);
      }
export function useGetAllLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllLocationsQuery, GetAllLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllLocationsQuery, GetAllLocationsQueryVariables>(GetAllLocationsDocument, options);
        }
// @ts-ignore
export function useGetAllLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllLocationsQuery, GetAllLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllLocationsQuery, GetAllLocationsQueryVariables>;
export function useGetAllLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllLocationsQuery, GetAllLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllLocationsQuery | undefined, GetAllLocationsQueryVariables>;
export function useGetAllLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllLocationsQuery, GetAllLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllLocationsQuery, GetAllLocationsQueryVariables>(GetAllLocationsDocument, options);
        }
export type GetAllLocationsQueryHookResult = ReturnType<typeof useGetAllLocationsQuery>;
export type GetAllLocationsLazyQueryHookResult = ReturnType<typeof useGetAllLocationsLazyQuery>;
export type GetAllLocationsSuspenseQueryHookResult = ReturnType<typeof useGetAllLocationsSuspenseQuery>;
export type GetAllLocationsQueryResult = Apollo.QueryResult<GetAllLocationsQuery, GetAllLocationsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/appointments/queries/getAllLocations.query.gql}
 */
export async function getAllLocations(
  variables: GetAllLocationsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetAllLocationsQuery['locations']>
export async function getAllLocations(
  variables: GetAllLocationsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetAllLocationsQuery>
export async function getAllLocations(
  variables: GetAllLocationsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetAllLocationsQuery['locations'] | GetAllLocationsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetAllLocationsQuery>(
    GetAllLocationsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.locations
}